import React, { useEffect, useRef, useState } from "react";
import classes from "./ProgressBar.module.scss";

type Props = {
  max: number;
  current: number;
};

const ProgressBar = (props: Props) => {
  const progressContainerRef = useRef<HTMLDivElement | null>(null);
  const [currentPosition, setCurrentPosition] = useState<number>(0);

  useEffect(() => {
    const progressContainer = progressContainerRef.current;
    const barWidth = progressContainer?.offsetWidth ?? 0;
    setCurrentPosition((barWidth / props.max) * props.current);
  }, [props]);

  return (
    <div className={classes.progressBarContainer}>
      <div className={classes.progressContainer} ref={progressContainerRef}>
        <div
          className={classes.progressBar}
          style={{ width: `${currentPosition}px` }}
        ></div>
        <span
          className={classes.startNumber}
          style={{ left: `${currentPosition - 22}px` }}
        >
          {props.current}
        </span>
        <span className={classes.endNumber}>{props.max}</span>
      </div>
    </div>
  );
};

export default ProgressBar;
